import type { BaseSliceState } from '../../types'

// A cook log entry ready to render. A just-written entry carries the server's estimated time.
export interface MealLogEntry {
  id: string
  mealId: string
  createdAt: Date
  text?: string
  cooked: boolean
  planId?: string
  cookId?: string
}

export interface MealHistory {
  // Newest first.
  entries: MealLogEntry[]
  cookCount: number
  lastCookedAt?: Date
}

export interface MealLogState extends BaseSliceState {
  entries: MealLogEntry[]
}

export enum MealLogActionTypes {
  SET_ENTRIES = 'mealLog/setEntries',
  SET_ERROR = 'mealLog/error',
  CLEAR = 'mealLog/clear'
}

export type MealLogAction =
  | { type: MealLogActionTypes.SET_ENTRIES; payload: MealLogEntry[] }
  | { type: MealLogActionTypes.SET_ERROR; payload: string }
  | { type: MealLogActionTypes.CLEAR }
